import React from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import CssBaseline from "@material-ui/core/CssBaseline";
import MomentUtils from "@date-io/moment";

import { GlobalStyles } from "./GlobalStyles";
import { theme } from "./theme";

interface IProps {
  children: React.ReactNode;
}

export const MuiProvider: React.FunctionComponent<IProps> = ({
  children
}: IProps) => (
  <MuiThemeProvider theme={theme}>
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </>
    </MuiPickersUtilsProvider>
  </MuiThemeProvider>
);
